import { useCallback } from 'react'
import log from 'loglevel'
import {
  ListVendorEvaluationCriteriaRequest,
  ListVendorEvaluationCriteriaResponse,
} from '@trustero/trustero-api-web/lib/vendormanagement/vendormanagement_pb'
import { VendorPromiseClient } from '@trustero/trustero-api-web/lib/vendormanagement/vendormanagement_grpc_web_pb'
import { NewGrpcResponse, GrpcResponse } from '../../hooks/types'
import { useSwrImmutableGrpc } from '../../useSwrImmutableGrpc'
import { useGrpcRevalidateByMethod } from '../../useGrpcMutate'

export const useVendorEvaluationCriteria = (
  vendorId?: string,
  shouldFetch = true,
): GrpcResponse<ListVendorEvaluationCriteriaResponse> => {
  const request = new ListVendorEvaluationCriteriaRequest()
  if (vendorId) {
    request.setVendorId(vendorId)
  }

  const { response } = useSwrImmutableGrpc(
    VendorPromiseClient.prototype.listVendorEvaluationCriteria,
    request,
    !!vendorId && shouldFetch,
  )

  return NewGrpcResponse(response)
}

export const useRefreshAfterEvaluationCriteriaSave =
  (): (() => Promise<void>) => {
    const mutateFunc = useGrpcRevalidateByMethod()
    return useCallback(async () => {
      try {
        await mutateFunc(
          VendorPromiseClient.prototype.listVendorEvaluationCriteria,
        )
      } catch (error) {
        log.error('Error refreshing after evaluation criteria save', error)
      }
    }, [mutateFunc])
  }
